import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import AlertModal from '../Modal/AlertModal';
import PrimaryButton, { styleTypes } from '../PrimaryButton';
import CancelButton from './css';

const LeavePageModal = ({
  // eslint-disable-next-line no-unused-vars
  isOpen, onClose, parentFields, onContinue,
}) => {
  const header = () => (
    <>{t('ConfirmModal')}</>
  );

  const content = () => (
    <>{t('AreYouSureYouWantToLeave')}</>
  );

  const actions = () => (
    <>
      <CancelButton
        type="button"
        smallWidth
        styleType={styleTypes.SECONDARY}
        onClick={onClose}
      >
        {t('Cancel')}
      </CancelButton>

      <PrimaryButton
        type="button"
        smallWidth
        iconRightArrow
        onClick={() => onContinue()}
      >
        {t('Continue')}
      </PrimaryButton>
    </>
  );

  return (
    <AlertModal
      isOpen={isOpen}
      onClose={onClose}
      header={header}
      content={content}
      actions={actions}
    />
  );
};

LeavePageModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  parentFields: PropTypes.object,
  onContinue: PropTypes.func,
};

export default LeavePageModal;
